module.exports = __webpack_public_path__ + "media/hyper/fonts/Nunito-Regular-7c16b0aeb76682f4a32c8532136d99fa.svg";